var m = require('mithril');
var prop = require('mithril/stream');
var treeEquipment = require('../locations/treeEquipment');
var loaders = require('../layout/components/loaders');

var nextInputId = 1;

function normalizeSingleRid(rawValue) {
  var trimmed = '';
  if (rawValue !== null && typeof rawValue !== 'undefined') {
    trimmed = String(rawValue).trim();
  }
  if (!trimmed) {
    return { normalized: null, hasValue: false, valid: true };
  }
  var prefixed = trimmed.charAt(0) === '#' ? trimmed : ('#' + trimmed);
  var valid = /^#\d+:\d+$/.test(prefixed);
  return { normalized: valid ? prefixed : null, hasValue: true, valid: valid };
}

function normalizeRidList(rawValue) {
  var rawText = rawValue !== null && typeof rawValue !== 'undefined'
    ? String(rawValue).trim()
    : '';
  if (!rawText) {
    return { normalized: '', hasValue: false, valid: true, values: [] };
  }

  var values = rawText.split(',').map(function (value) {
    return normalizeSingleRid(value);
  });
  var invalid = values.some(function (state) {
    return !state.hasValue || !state.valid;
  });

  if (invalid) {
    return { normalized: null, hasValue: true, valid: false, values: [] };
  }

  var normalizedValues = values.map(function (state) {
    return state.normalized;
  }).filter(function (value, index, list) {
    return list.indexOf(value) === index;
  });

  return {
    normalized: normalizedValues.join(', '),
    hasValue: normalizedValues.length > 0,
    valid: true,
    values: normalizedValues
  };
}

function normalizedRid(rawValue) {
  var state = normalizeSingleRid(rawValue);
  return state.valid && state.hasValue ? state.normalized : '';
}

function streamValue(stream) {
  return typeof stream === 'function' ? stream() : stream;
}

function setStreamValue(stream, value) {
  if (typeof stream === 'function') {
    stream(value);
  }
}

function textValue(value) {
  if (Array.isArray(value)) {
    return value.join(', ');
  }
  return value == null ? '' : String(value);
}

function pushError(errors, message) {
  if (!message) return;
  if (Array.isArray(errors)) {
    errors.push(message);
  }
}

function formatEquipmentSelectionPath(record) {
  if (!record) {
    return '';
  }
  if (record._pathLabel) {
    return record._pathLabel;
  }
  if (typeof record.path === 'string') {
    return record.path;
  }
  if (Array.isArray(record.path)) {
    return record.path.map(function (pathRecord) {
      if (!pathRecord) return '';
      if (pathRecord.name === 'root') return 'Home';
      return pathRecord.roomNumber
        ? ((pathRecord.name || pathRecord['@class'] || '') + ' ' + pathRecord.roomNumber).trim()
        : (pathRecord.name || pathRecord['@class'] || '');
    }).filter(Boolean).join(' / ');
  }
  return record.name || record['@class'] || record['@rid'] || '';
}

function pathLabelForFlatEntry(entry) {
  if (!entry) {
    return '';
  }
  return entry.path || entry.name || entry.class || entry['@class'] || entry.rid || entry['@rid'] || '';
}

function recordDisplayName(record) {
  if (!record) {
    return '';
  }
  if (record.name === 'root' || record['@class'] === 'Home') {
    return 'Home';
  }
  return record.roomNumber
    ? ((record.name || record['@class'] || record.class || '') + ' ' + record.roomNumber).trim()
    : (record.name || record['@class'] || record.class || '');
}

function cachePathFromTreeNode(ctrl, node, ancestors) {
  if (!node) {
    return;
  }
  var rid = normalizedRid(node['@rid'] || node.rid);
  var nextAncestors = ancestors || [];
  var label = recordDisplayName(node);
  var pathParts = nextAncestors.concat(label ? [label] : []).filter(Boolean);
  if (rid && pathParts.length) {
    ctrl.pathByRid[rid] = pathParts.join(' / ');
  }
  (node.children || []).forEach(function (child) {
    cachePathFromTreeNode(ctrl, child, pathParts);
  });
}

function rememberEquipmentRecord(ctrl, record) {
  var rid = normalizedRid(record && record['@rid']);
  var path = formatEquipmentSelectionPath(record);
  if (rid && path) {
    ctrl.pathByRid[rid] = path;
  }
}

function safeRedraw() {
  if (typeof m.redraw !== 'function') {
    return;
  }
  try {
    m.redraw();
  } catch (err) {
    // Tests using m.render do not always install Mithril's redraw scheduler.
  }
}

function handleKeyboardAction(ev, action) {
  if (ev.key !== 'Enter' && ev.key !== ' ') {
    return;
  }
  ev.preventDefault();
  action(ev);
}

function renderFieldLabel(label, inputId) {
  if (!label) {
    return null;
  }
  return m('div.element-field-label', [
    m('name', { for: inputId }, label)
  ]);
}

function renderButtonContent(iconClass, text, pathTitle) {
  return m('span.equipment-selection-button-content', [
    iconClass ? m('i.mr1.' + iconClass) : null,
    m('span.equipment-selection-button-label' + (pathTitle ? '.is-path' : ''), pathTitle ? {
      title: pathTitle
    } : {}, text)
  ]);
}

function renderLocalButton(className, children, action) {
  return m('div.f4.ba.bw1.ph3.pv2.tc.v-btm.' + className, {
    onclick: action,
    onkeydown: function (ev) {
      handleKeyboardAction(ev, action);
    },
    role: 'button',
    tabindex: 0
  }, children);
}

function appendRidValue(currentValue, rid) {
  var currentState = normalizeRidList(currentValue);
  var values = currentState.valid ? currentState.values.slice() : [];
  var nextRid = normalizeSingleRid(rid);
  if (!nextRid.valid || !nextRid.hasValue) {
    return currentState.valid ? currentState.normalized : String(currentValue || '');
  }
  if (values.indexOf(nextRid.normalized) === -1) {
    values.push(nextRid.normalized);
  }
  return values.join(', ');
}

function removeRidValue(currentValue, rid) {
  var currentState = normalizeRidList(currentValue);
  if (!currentState.valid) {
    return String(currentValue || '');
  }
  var normalized = normalizedRid(rid);
  return currentState.values.filter(function (value) {
    return value !== normalized;
  }).join(', ');
}

function selectedEquipmentItems(values, pathByRid) {
  return values.map(function (rid) {
    return {
      rid: rid,
      path: pathByRid[rid] || rid
    };
  });
}

module.exports = {
  oninit: function (vnode) {
    this.showTree = false;
    this.selectedNode = prop(null);
    this.inputId = vnode.attrs.inputId || ('equipment-selector-input-' + nextInputId++);
    this.rawRidView = false;
    this.pathByRid = {};
    this.pathLookupComplete = false;
    this.pathLookupPromise = null;
    this.ensurePathLabels = function (rids) {
      var ctrl = this;
      var missing = (rids || []).some(function (rid) {
        return rid && !ctrl.pathByRid[rid];
      });
      if (!missing || ctrl.pathLookupComplete || ctrl.pathLookupPromise) {
        return;
      }
      ctrl.pathLookupPromise = loaders.requestWithLoader({
        loader: 'main',
        url: '/api/v1/location/descendant-tree',
        method: 'GET'
      }).then(function (res) {
        ctrl.pathLookupPromise = null;
        ctrl.pathLookupComplete = true;
        (res && res.flat || []).forEach(function (entry) {
          var rid = normalizedRid(entry && (entry.rid || entry['@rid']));
          var path = pathLabelForFlatEntry(entry);
          if (rid && path) {
            ctrl.pathByRid[rid] = path;
          }
        });
        if (res && res.root) {
          cachePathFromTreeNode(ctrl, res.root, []);
        }
        safeRedraw();
      }).catch(function (err) {
        ctrl.pathLookupPromise = null;
        ctrl.pathLookupComplete = true;
        console.error('Failed to load equipment selector paths', err);
      });
    };
  },

  view: function (vnode) {
    var ctrl = this;
    var attrs = vnode.attrs || {};
    var currentValue = textValue(streamValue(attrs.value));
    var multiple = attrs.multiple === true;
    var ridListState = multiple ? normalizeRidList(currentValue) : null;
    var currentRidValues = multiple && ridListState.valid ? ridListState.values : [];
    var showRawRidView = !!(multiple && (ctrl.rawRidView || (currentValue && !ridListState.valid)));
    var selectedEquipment = ctrl.selectedNode && ctrl.selectedNode();
    var selectedEquipmentRid = selectedEquipment && selectedEquipment['@rid'];
    var selectedEquipmentPath = formatEquipmentSelectionPath(selectedEquipment);
    var buttonUsesPath = !!(
      !multiple &&
      selectedEquipmentPath &&
      !ctrl.showTree &&
      currentValue === selectedEquipmentRid
    );
    var toggleText = buttonUsesPath
      ? selectedEquipmentPath
      : ctrl.showTree ? 'Cancel' : 'Select Equipment';
    var inputId = attrs.inputId || ctrl.inputId;
    var invalidMessage = attrs.invalidMessage || 'Invalid format for equipment Rid. Please use the format "#<clusterId>:<recordId>"';
    var initialTreeRid = multiple && currentRidValues.length ? currentRidValues[0] : currentValue;

    if (multiple) {
      ctrl.ensurePathLabels(currentRidValues);
    }

    function toggleTree() {
      ctrl.showTree = !ctrl.showTree;
    }

    function confirmSelection() {
      var chosen = ctrl.selectedNode();
      if (chosen && chosen['@rid']) {
        rememberEquipmentRecord(ctrl, chosen);
        setStreamValue(attrs.value, multiple ? appendRidValue(streamValue(attrs.value), chosen['@rid']) : chosen['@rid']);
        ctrl.showTree = false;
        ctrl.rawRidView = false;
        if (typeof attrs.onselect === 'function') {
          attrs.onselect(chosen);
        }
      } else {
        pushError(attrs.errors, attrs.requiredSelectionMessage);
      }
    }

    function toggleRawRidView(ev) {
      ev.preventDefault();
      ctrl.rawRidView = !ctrl.rawRidView;
    }

    function removeSelectedRid(rid) {
      setStreamValue(attrs.value, removeRidValue(streamValue(attrs.value), rid));
    }

    function renderRawRidToggle() {
      return m('button.equipment-selector-raw-toggle', {
        type: 'button',
        onclick: toggleRawRidView
      }, showRawRidView ? 'View paths' : 'View RIDs');
    }

    function renderRidInput() {
      return m('input.form-control.equipment-selector-rid' + (multiple ? '.is-multiple' : ''), {
        id: inputId,
        type: 'text',
        autocomplete: 'off',
        placeholder: attrs.placeholder || '#<clusterId>:<recordId>',
        oninput: function (ev) {
          setStreamValue(attrs.value, ev.target.value);
          ctrl.selectedNode(null);
        },
        onblur: function (ev) {
          var rawValue = ev.target.value;
          if (attrs.singleOnlyMessage && String(rawValue || '').indexOf(',') !== -1) {
            pushError(attrs.errors, attrs.singleOnlyMessage);
            return;
          }
          var nextState = multiple ? normalizeRidList(rawValue) : normalizeSingleRid(rawValue);
          if (!nextState.hasValue) {
            setStreamValue(attrs.value, multiple ? '' : null);
            ev.target.value = '';
            return;
          }
          if (!nextState.valid) {
            pushError(attrs.errors, invalidMessage);
            ctrl.rawRidView = true;
            return;
          }
          setStreamValue(attrs.value, nextState.normalized);
          ev.target.value = nextState.normalized;
        },
        value: currentValue || '',
      });
    }

    function renderEquipmentBadge(item) {
      return m('span.equipment-selector-badge', {
        key: item.rid,
        title: item.path
      }, [
        m('span.equipment-selector-badge-label', item.path),
        m('button.equipment-selector-badge-remove', {
          type: 'button',
          title: 'Remove ' + item.rid,
          'aria-label': 'Remove ' + item.rid,
          onclick: function (ev) {
            ev.preventDefault();
            removeSelectedRid(item.rid);
          }
        }, [
          m('i.ion-close', { 'aria-hidden': 'true' })
        ])
      ]);
    }

    function renderMultiEquipmentValue() {
      if (showRawRidView) {
        return m('div.equipment-selector-raw-field', [
          renderRidInput(),
          renderRawRidToggle()
        ]);
      }
      var selectedItems = selectedEquipmentItems(currentRidValues, ctrl.pathByRid);
      return m('div.equipment-selector-selected-panel', [
        m('div.equipment-selector-selected-tools', [
          renderRawRidToggle()
        ]),
        selectedItems.length
          ? m('div.equipment-selector-badges', selectedItems.map(renderEquipmentBadge))
          : m('div.equipment-selector-empty', 'No equipment selected')
      ]);
    }

    return m('div', {
      class: 'form-group mb2 equipment-selector' + (ctrl.showTree ? ' is-expanded' : '') + (attrs.class ? (' ' + attrs.class) : '')
    }, [
      typeof attrs.renderLabel === 'function'
        ? attrs.renderLabel(inputId)
        : renderFieldLabel(attrs.label, inputId),
      m('div.equipment-selector-row', [
        m('div.equipment-selector-action', [
          renderLocalButton('blue.equipment-selection-toggle-button', [
            renderButtonContent(
              'blue.' + (ctrl.showTree ? 'ion-close' : 'ion-chevron-down'),
              toggleText,
              buttonUsesPath ? selectedEquipmentPath : null
            )
          ], toggleTree)
        ]),
        multiple ? renderMultiEquipmentValue() : renderRidInput()
      ]),

      ctrl.showTree && m('div.equipment-selector-tree.mb2', [
        m(treeEquipment, {
          initialRid: initialTreeRid,
          selectedNode: ctrl.selectedNode
        }),
        m('div.w-100.cf', {
          style: { visibility: ctrl.selectedNode() ? 'visible' : 'hidden' }
        }, [
          renderLocalButton('fr.green.mv2.equipment-selection-confirm-button', 'Select Equipment', confirmSelection)
        ])
      ])
    ]);
  }
};
